export class MensagemPersonalizada {
  variaveis = [];
  dataEnvio = new Date();

  constructor(body) {
    this.contexto = body.contexto;
    this.mensagem = body.mensagem;
    this.ativado = body.ativado;
    this.tipo = body.tipo;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setVariaveis(variaveis) {
    this.variaveis = variaveis;
  }

  setListaPessoaIds(arrayIdPessoa) {
    this.pessoaIds = arrayIdPessoa;
  }
}
